import React from 'react'
import './project.css'
import projects from './project.json'

const Projects = () => {
  return (
    <div id='Project'>
      <h1 className='heading'>PROJECTS</h1>
        <div className='pro'>
            {projects.map((project,index)=>{
                return <div key={index} className='project'>
                    <h2 className='project-heading'>Title : {project.Title}</h2>
                    <p className='project-desc'>Environment : {project.Environment}</p>
                    <p className='project-desc'>Role : {project.Role}</p>
                    <p className='project-desc'>Languages Used : {project.Languages}</p>
                    <p className='project-desc'>Team Size : {project.TeamSize}</p>
                    <p className='project-desc'>GitHub Link : {project.Git}</p>
                </div>  
            })}
        </div>
    </div>
  )
}

export default Projects